import React, { JSX } from 'react';
import { AppBar, Box, Dialog, IconButton, Paper, Slide, Toolbar, Typography } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { TransitionProps } from '@mui/material/transitions';
import * as Types from 'types/types';
import { Scrollable } from 'components/Scrollable';
import { JobInfo } from './JobInfo';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function JobsDetailsPanel(props: {
  open: boolean;
  selectedJob: Types.Job | null;
  onClose: () => void;
}): JSX.Element | null {
  if (!props.open) return null;

  return (
    <Scrollable
      sx={{ display: 'flex', flex: 1, flexDirection: 'row', height: '100%', width: '100%' }}
    >
      <Paper sx={{ flex: 1, ml: 1, flexGrow: 1, height: 'max-content' }}>
        {props.selectedJob ? (
          <JobInfo variant="all" job={props.selectedJob} onClose={props.onClose} />
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              color: 'text.secondary',
              textAlign: 'center',
              p: 2,
            }}
          >
            <Typography variant="body2">Select a job to view details</Typography>
          </Box>
        )}
      </Paper>
    </Scrollable>
  );
}

export function JobsMobileDialog(props: {
  open: boolean;
  selectedJob: Types.Job | null;
  onClose: () => void;
}): JSX.Element {
  return (
    <Dialog fullScreen open={props.open} onClose={props.onClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={props.onClose}>
            <ArrowBackIcon />
          </IconButton>
          <Box sx={{ ml: 2, flex: 1 }}>
            <Typography variant="h6" noWrap>
              {props.selectedJob?.title}
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }} noWrap>
              {props.selectedJob?.company}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      {props.selectedJob && <JobInfo variant="all" job={props.selectedJob} inDialog />}
    </Dialog>
  );
}
